"use client"

import { Info } from "lucide-react"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import {
  ATTRIBUTION_MODEL_OPTIONS,
  parseAttributionModel,
  type AttributionModelKey,
} from "@/lib/attribution/attribution-models"
import { useTranslations } from "next-intl"


interface AttributionModelSelectProps {
  value: AttributionModelKey
  onChange: (model: AttributionModelKey) => void
}

export function AttributionModelSelect({ value, onChange }: AttributionModelSelectProps) {
  const tUi = useTranslations("Shopify.ShopifyAttributionDashboardAttributionModelSelect")

  return (
    <>
      <span className="flex items-center gap-1 text-sm font-medium text-muted-foreground">
        <span><span key={tUi("model")}>{tUi("model")}</span></span>
        <TooltipProvider delayDuration={300}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Info className="h-3.5 w-3.5 cursor-help" aria-label={tUi("aboutAttributionModels")} />
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-[300px]">
              <ul className="space-y-1 text-xs">
                {ATTRIBUTION_MODEL_OPTIONS.map((option) => (
                  <li key={option.key}>
                    <span className="font-medium">{option.label}</span>
                    <span> — </span>
                    <span>{option.description}</span>
                  </li>
                ))}
              </ul>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </span>
      <Select value={value} onValueChange={(next) => onChange(parseAttributionModel(next))}>
        <SelectTrigger className="w-[210px]" aria-label={tUi("attributionModel")}>
          <SelectValue placeholder={tUi("selectModel")} />
        </SelectTrigger>
        <SelectContent>
          {ATTRIBUTION_MODEL_OPTIONS.map((option) => (
            <SelectItem key={option.key} value={option.key} description={option.description} className="max-w-[320px]">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  )
}
